import API from "@utils/request";

let Language = localStorage.getItem('currentLanguage');
let prout = 'protal';
if (!Language || Language === 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}

// 获取积分商城商品列表（后端路由组：apigoods）
export async function getGoodsList(params) {
  try {
    return await API.post("/api/" + prout + "/api/goods/goodsList", params);
  } catch (error) {
    return error;
  }
}

// 获取商品详情（后端路由组：apigoods）
export async function getGoodsDetail(params) {
  try {
    return await API.post("/api/" + prout + "/api/goods/goodsDetail", params);
  } catch (error) {
    return error;
  }
}

// 获取商品类型字典（GOODS_TYPE）
export async function getGoodsTypes(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/goodsTypes", params);
  } catch (error) {
    return error;
  }
}

// 获取商品兑换说明（最新一条或指定ID）
export async function getGoodsInstructions(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/goodsInstructions", params);
  } catch (error) {
    return error;
  }
}

// 地址列表
export async function addressList(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/addressList", params);
  } catch (error) {
    return error;
  }
}

// 地址保存（新增或编辑，带 tua_id 为编辑）
export async function addressSave(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/addressSave", params);
  } catch (error) {
    return error;
  }
}

// 地址删除（软删除）
export async function addressDelete(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/addressDelete", params);
  } catch (error) {
    return error;
  }
}

// 立即兑换（下单）
export async function exchange(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/exchange", params);
  } catch (error) {
    return error;
  }
}

// 兑换前验证（登录/积分/库存/时间窗口）
export async function exchangeValidate(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/exchangeValidate", params);
  } catch (error) {
    return error;
  }
}

// 订单列表
export async function orderList(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/orderList", params);
  } catch (error) {
    return error;
  }
}

// 订单详情
export async function orderInfo(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/orderInfo", params);
  } catch (error) {
    return error;
  }
}

// 确认收货
export async function confirmReceive(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/confirmReceive", params);
  } catch (error) {
    return error;
  }
}

// 获取当前用户积分
export async function getMyPoints(params = {}) {
  try {
    return await API.post("/api/" + prout + "/api/goods/getMyPoints", params);
  } catch (error) {
    return error;
  }
}